import { useErrorContext } from "shared";
import { Activity } from "routes/patient/queries/useSchedule";
import ConfirmDialog from "shared/ConfirmDialog";
import { IconButton } from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { useId } from "utils/hooks";
import useDeleteActivity from "routes/patient/queries/useDeleteActivity";
import { useQueryClient } from "react-query";
import { queryKeys } from "utils/misc";
import { useTranslation } from "react-i18next";

interface Props {
  activity: Activity;
}

const RemoveActivity: React.VFC<Props> = ({ activity }) => {
  const id = useId();
  const { mutateAsync: deleteActivity } = useDeleteActivity();
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const setErrors = useErrorContext();

  const onRemove = async () => {
    try {
      // @ts-ignore
      await deleteActivity(activity.user_activity_id);
    } catch (error) {
      setErrors(t`errors.could_not_remove_activity`, error);
    } finally {
      queryClient.invalidateQueries(queryKeys.schedule(id, activity.course_week_number!));
    }
  };

  return (
    <ConfirmDialog
      type="warning"
      title={t("patient.remove_item_title", { name: activity.type })}
      confirmText={t`buttons.remove`}
      onConfirm={() => onRemove()}
      OpenButton={props => (
        <IconButton {...props} size="small" aria-label={t`buttons.remove`}>
          <DeleteIcon fontSize="small" />
        </IconButton>
      )}
    />
  );
};

export default RemoveActivity;
